import React, { Component } from "react";
import LogoSendero from "./../assets/images/logo/LogoSendero.png";

import { Link } from "react-router-dom";
class Logo extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }
  render() {
    const { add_class } = this.props;
    return (
      <div className={"logo " + add_class}>
        <Link to={"/"}>
          <img src={LogoSendero} alt="Sendero" /> 
        </Link>
      </div>
    );
  }
}

export default Logo;
